module.exports = __webpack_public_path__ + "img/artist.aee06b59.jpg";